import { StoreActionApi } from "react-sweet-state";

import { Container } from "../state/types";

interface State extends Container
{
    initialized: boolean;
    loading: boolean;
    loadQueued: boolean;
    loadFailure: boolean;
    updating: boolean;
    updateFailure: boolean;
}

const StateDefaults: State = {
    initialized: false,
    loading: false,
    loadQueued: false,
    loadFailure: false,
    updating: false,
    updateFailure: false
}

type StoreApi<S extends State> = StoreActionApi<S>;

const StateModifiers = {

    startLoading: (state: State) =>
    {
        state.loading = true;
        state.loadFailure = false;
    },

    stopLoading: (state: State, success: boolean): void =>
    {
        state.loadFailure = !success;
        state.initialized =
            state.initialized ||
            success;
        state.loading = false;
    },

    startUpdating: (state: State): void =>
    {
        state.updating = true;
        state.updateFailure = false;
    },

    stopUpdating: (state: State, success: boolean): void =>
    {
        state.updateFailure = !success;
        state.updating = false;
    },

    reset: (state: State) =>
    {
        state.loadFailure = false;
        state.updateFailure = false;
    }

};

export
{
    StateModifiers as LoadingStateModifiers,
    State as LoadingState,
    StateDefaults as LoadingStateDefaults,
    StoreApi as LoadingStateStoreApi
}